<template>
  <b-modal ref="passwordPrompt" id="passwordPrompt" centered lazy
           :title="modalTitle"
           :cancel-title="$t('Cancel')"
           :header-class="hasToSetPassword ? 'border-0' : ''"
           :footer-class="hasToSetPassword ? 'border-0' : ''"
           :body-class="hasToSetPassword ? 'd-none' : ''"
           :ok-title="$t('Delete Account')" ok-variant="danger" @hidden="clearPasswordPrompt" @ok="deleteAccount">

    <b-alert variant="info" :show="agreement">
      {{$t('Withdrawal of agreement')}}
    </b-alert>

    <b-alert dismissible
             fade
             :show="isPasswordError"
             @dismissed="passwordError = ''"
             variant="warning">
      {{ passwordError }}
      <template slot="dismiss" class="pull-right">
        &nbsp;
      </template>
    </b-alert>

    <input type="password" class="form-control" v-model="password" :placeholder="$t('Password')">
  </b-modal>
</template>

<script>
import {mapActions, mapState} from 'vuex'

  export default {
    name: "DeleteAccountPasswordPromptModal",
    props: {
      agreement: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        password: '',
        passwordError: '',
      }
    },
    methods: {
      ...mapActions([
        'logout',
        'setLoginInfo'
      ]),
      show() {
        this.$refs.passwordPrompt.show();
      },
      deleteAccount(e) {
        e.preventDefault();

        if (!this.password.length && !this.hasToSetPassword) {
          this.passwordError = this.$t('Give password');
          return;
        }

        this.$http.post('account/delete', {
          password: this.password
        })
          .then((r) => {
            if (r.data.success) {
              this.$refs.passwordPrompt.hide();
              this.setLoginInfo(r.data.message);
              this.logout();
            } else {
              this.passwordError = r.data.message;
            }
          });
      },
      clearPasswordPrompt() {
        this.passwordError = '';
        this.password = '';
      }
    },
    computed: {
      ...mapState({
        hasToSetPassword: state => state.auth.user.set_password,
      }),
      isPasswordError() {
        return !!this.passwordError.length
      },
      modalTitle() {
        if (this.hasToSetPassword) {
          return this.$t('Confirm deleting account');
        }

        return this.agreement
          ? this.$t('Confirm withdrawal agreement and deleting account')
          : this.$t('Provide password to delete account')
      }
    }
  }
</script>

<style scoped>

</style>
